/**
 * Created by tomers on 3/29/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Config = require("personalization-web-agent-config/config.json");
    var EngagementAreaController = {};

    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {

        EngagementAreaController = Marionette.Controller.extend({
            initialize: function (options) {
                this._initialize(options);
            },


            getFakePageCallback: function() {
                return _.bind(this._callback, this);
            },


            _initialize: function(options) {
                LEPersonalization.logger.info("initializing", "EngagementAreaController:_initialize", options);

                this.featureId = options.featureOptions.id;
            },

            _callback: function () {
                LEPersonalization.navigateToPageMenu({
                    module:"LEWebAgent",
                    page: Config.SIMULATED_ENGAGEMENT_PAGE
                });
            }
        });
    });
    return EngagementAreaController;

});
